import React from "react";
import PredictionPage from "../../components/PredictionPage";

function Ethereum() {
  return (
    <PredictionPage
      title="Ethereum"
      content="This is the Ethereum AI Trading Predictions page."
      canonical="/cryptocurrencies/ethereum-ai-trading-predictions"
      categoryKey="nav.cryptocurrencies"
      categoryPath="/cryptocurrencies"
      symbol="ETHEREUM"
    />
  );
}

export default Ethereum;
